export default __webpack_public_path__ + "static/bg4-710df3ed7faf17ea19d81df18585e5f9.png";